import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import Chip from '@mui/material/Chip';
import { useCallback } from 'react';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { thunkShowPlayerInfo } from '../../redux/actions/playerInfoActions';
import { useAppDispatch } from '../../redux/store';
import { FRIENDS_PANEL_LIST_ITEM_HOVER_COLOR } from '../../styles/colors';
import { PanelItem } from '../panelItem';
export const AllFriendsPanelItem = ({ playerId, username, isOnline }) => {
    const dispatch = useAppDispatch();
    const socketSend = useSocketSend();
    const onClick = useCallback(() => {
        dispatch(thunkShowPlayerInfo({ id: playerId, name: username }, socketSend));
    }, [dispatch, playerId, username, socketSend]);
    return (_jsxs(PanelItem, { onClick: onClick, hoverColor: FRIENDS_PANEL_LIST_ITEM_HOVER_COLOR, ariaLabel: username, children: [_jsx("div", { children: username }), isOnline && _jsx(Chip, { icon: _jsx(CheckCircleOutlineRoundedIcon, {}), size: 'small', label: 'Online', variant: 'outlined' })] }));
};
